import * as types from './actionsTypes'
import { VOUCHERS_PAGINATION_SIZE } from './utils'

const initialState = {
  list: [],
  page: 1,
  hasMore: false,
  isLoadingDetails: false,
  details: null,
  errorDetails: null,
  checkStatusServiceIsLoading: false,
  receipts: {},
}

export const tollVouchers = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_SHIPPING_TOLL_VOUCHER:
      return {
        ...state,
        list: payload.page === 1 ? payload.data : [...state.list, ...payload.data],
        hasMore: payload.data.length >= VOUCHERS_PAGINATION_SIZE,
        page: payload.page,
      }
    case types.IS_LOADING_VOUCHER_DETAILS:
      return { ...state, isLoadingDetails: payload }
    case types.FIND_SHIPPING_TOLL_VOUCHER:
      return {
        ...state,
        details: payload,
      }
    case types.CHECK_STATUS_LOADING:
      return {
        ...state,
        checkStatusServiceIsLoading: payload,
      }
    case types.SET_RECEIPT_LOADING:
      return {
        ...state,
        receipts: {
          ...state.receipts,
          [payload.id]: {
            isLoading: payload.value,
          },
        },
      }
    case types.SET_ERROR_DETAILS:
      return {
        ...state,
        errorDetails: payload,
      }
    default:
      return { ...state }
  }
}
